var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg413(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "translate(1.775100, 1.000000)",
    strokeWidth: 1.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M8.58473537,28.708651 C8.46172757,28.7120685 8.33895492,28.6959585 8.22097126,28.6609186 C4.03319742,27.2209895 1.50410506,25.0291013 0.703755002,22.1485513 C0.171223682,20.23026 -0.0555249105,17.7585489 0.0114297727,14.5909125 C0.196763097,5.81955487 6.06668708,1.77635684e-14 9.86860867,1.77635684e-14 C13.6763974,1.77635684e-14 19.187044,4.96452131 19.187044,13.9420278 C19.187044,14.4608588 19.1939465,15.0004431 19.2011942,15.5438322 C19.2357069,18.114467 19.2702196,20.7736491 18.6096461,22.6639235 C18.0878137,24.4753356 15.9197244,25.9259872 14.1947785,26.8169931 C12.5474863,27.667876 9.78646839,28.708651 8.58473537,28.708651 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.224900, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    x1: 3.2249,
    y1: 6.5,
    x2: 15.2249,
    y2: 24.5,
    stroke: "none",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg413);
export default __webpack_public_path__ + "static/media/4-13.09752302e14ad9bdbe3e8211cff389e2.svg";
export { ForwardRef as ReactComponent };